import QuickSight from './QuickSight';

export default QuickSight;
